import { render, staticRenderFns } from "./VesselCrewTable.vue?vue&type=template&id=4392cfbb&scoped=true&"
import script from "./VesselCrewTable.vue?vue&type=script&lang=js&"
export * from "./VesselCrewTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4392cfbb",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VTextField})
